module.exports = __webpack_public_path__ + "resources/img/img_criminal_ip_for_asm1_m_jp.7d565f63d8a4a69e3d8fbd5418965e0e.png";